import { ModalBody, ModalFooter } from 'reactstrap';
import styled from 'styled-components';

const ModalTitle = styled.h1`
	font-size: 24px;
	font-weight: bold;
	color: #f47920;
	margin-bottom: 24px;
`;

const Chip = styled.div`
	display: flex;
	justify-content: center;
	min-width: 52px;
	font-size: 16px;
	font-weight: bold;
	line-height: 100%;
	color: #fff;
	background-color: #f47920;
	box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.15);
	border: 0;
	border-radius: 4px;
	padding: 8px 12px;
	cursor: pointer;
	transition: all 0.25s cubic-bezier(0.02, 0.01, 0.47, 1);

	@media (max-width: 600px) {
		font-size: 14px;
	}
`;

const ButtonContainer = styled.div`
	max-width: 396px;
	width: 100%;
	margin: 24px 0 12px 0;
	display: flex;
	flex-direction: row-reverse;
	align-items: center;
	justify-content: space-between;
	column-gap: 12px;
	float: right;
`;

const ModalContent = styled(ModalBody)`
	padding: 0;
	p,
	span {
		font-size: 16px;
		font-weight: bold;
		color: #575757;
		margin-bottom: 24px;
	}

	@media (max-width: 768px) {
		min-width: 300px;
	}

	@media (max-width: 600px) {
		min-width: 300px;
		p,
		span {
			font-size: 14px;
		}
	}

	@media (max-width: 350px) {
		min-width: auto;
	}
`;

const ModalContentFooter = styled(ModalFooter)`
	padding: 8px;
`;

export { ButtonContainer, Chip, ModalTitle, ModalContent, ModalContentFooter };
